var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol0, _symbol1, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctypeSprite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    display: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "ai",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFC35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1 20.2c-.2 0-.3 0-.3-.2l-.4-.8H6.2l-.3.8c-.1.2-.2.2-.3.2-.2 0-.3-.1-.3-.3v-.1l1.6-3.9c0-.1.2-.3.4-.3s.4.2.5.3l1.5 3.9c0 .1.1.1.1.1 0 .2-.2.3-.3.3zm-1.8-3.9l-.9 2.4h1.9l-1-2.4zm3.2 3.9c-.1 0-.3-.1-.3-.3v-4c0-.1.2-.3.3-.3.2 0 .3.2.3.3v4c0 .2-.1.3-.3.3z",
    fill: "#fff"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "attachment",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fill: "#8199AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#617F9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15.6c.4-.5.4-1.2 0-1.6s-1.1-.4-1.6 0l-3.4 3.4c-.4.5-.4 1.2 0 1.6s1.1.4 1.5 0l2.1-2.1c.2-.1.2-.3 0-.5s-.3-.1-.4 0l-1.3 1.4c-.2.2-.5.2-.7 0-.2-.2-.2-.5 0-.7L9 15.8c.5-.5 1.3-.5 1.8 0s.5 1.3 0 1.7l-2.1 2.2c-.8.7-2.1.7-2.9 0-.8-.8-.8-2.1 0-2.9l3.5-3.5c.8-.8 2-.8 2.8 0 .8.8.8 2.1 0 2.9l-.3.4c0-.4-.1-.7-.4-1l.1-.1z",
    fill: "#fff"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "audio",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fill: "#379FD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.3 2.1h4.8z",
    fill: "#2987C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 12.8l-5.3.6v5.1c-.3-.1-.6-.1-1 0-.7.1-1.2.6-1.1 1.1.2.4.9.7 1.6.5.7-.1 1.2-.5 1.2-.9v-4l3.9-.5v3.1c-.3-.1-.6-.1-1 0-.8.1-1.3.6-1.1 1.1.1.4.9.7 1.6.5.7-.1 1.2-.5 1.2-1v-5.6z",
    fill: "#fff"
  })))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "box_notes",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#277A84",
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E5B60",
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#fff",
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.7 14.8l.8-.8H5.4s-.1 0-.1.1v.5c0 .1.1.1.1.1h6.3zm-2.8 2.7l.8-.8H5.4s-.1 0-.1.1v.5l.1.2h3.5zM7 20.2l.1-.8H5.4s-.1 0-.1.2v.5c0 .1.1.1.1.1H7zm.3 0h.8c.1-.1.2-.1.2-.1l4.9-5s-.2.2-.6-.2c-.3-.3-.2-.5-.2-.5l-4.8 4.8c-.1.1-.1.2-.1.2 0 .1-.2.8-.2.8zm5.7-6.4l-.4.4v.2c0 .1.2.5.6.6 0 0 .1 0 .2-.1.1 0 .4-.4.4-.4s.1 0 0-.2c0-.2-.3-.5-.6-.6-.1 0-.2.1-.2.1z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "csv",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#45B058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1 16.2c.1.1.1.1.1.2s-.1.3-.3.3c0 0-.1-.1-.2-.1-.2-.3-.7-.5-1.1-.5-1 0-1.7.7-1.7 1.8s.7 1.8 1.7 1.8c.4 0 .9-.2 1.1-.5.1-.1.2-.1.2-.1.2 0 .3.2.3.3 0 .1 0 .1-.1.2-.3.3-.8.6-1.5.6-1.3 0-2.3-.9-2.3-2.3s1-2.3 2.3-2.3c.7 0 1.2.2 1.5.6zm2.6 4c-.7 0-1.2-.2-1.6-.5-.1-.1-.1-.2-.1-.2 0-.2.1-.3.3-.3h.1c.3.3.8.5 1.3.5.8 0 1-.4 1-.8 0-1.1-2.6-.5-2.6-2.1 0-.7.6-1.2 1.5-1.2.6 0 1.1.1 1.5.4 0 .1.1.2.1.2 0 .2-.2.3-.3.3h-.2c-.3-.3-.7-.4-1.1-.4-.6 0-.9.3-.9.7 0 1 2.6.4 2.6 2.1 0 .6-.4 1.3-1.6 1.3zM18 16l-1.5 3.9c-.1.2-.3.3-.5.3s-.4-.1-.4-.3L14 16v-.1c0-.1.1-.3.3-.3.1 0 .2.1.3.2l1.4 3.7 1.5-3.7c0-.1.1-.2.3-.2.1 0 .3.1.3.3 0 0 0 .1-.1.1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.3 2.1h4.8z",
    fill: "#349C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "eps",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFC35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20.2H5.7c-.2 0-.4-.2-.4-.4v-3.7c0-.2.2-.4.4-.4H8c.2 0 .3.1.3.3 0 .1-.1.2-.3.2H5.9v1.5H8c.1 0 .2.1.2.2 0 .2-.1.3-.2.3H5.9v1.5H8c.2 0 .3.1.3.3 0 .1-.1.2-.3.2zm3.1-1.8H9.9V20c0 .1-.2.3-.3.3-.2 0-.3-.2-.3-.3v-3.9c0-.2.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.4 0 .7-.5 1.3-1.4 1.3zm-.1-2.2H9.9v1.7H11c.6 0 .9-.3.9-.8s-.3-.9-.9-.9zm3.9 4.1c-.7 0-1.2-.2-1.6-.6 0 0-.1-.1-.1-.2s.1-.2.3-.2h.2c.3.3.7.5 1.2.5.8 0 1.1-.4 1.1-.8 0-1.1-2.7-.5-2.7-2.1 0-.7.7-1.3 1.6-1.3.5 0 1 .2 1.4.5.1.1.1.2.1.2 0 .2-.1.3-.3.3 0 0-.1 0-.1-.1-.4-.2-.8-.4-1.2-.4-.5 0-.9.3-.9.8 0 1 2.7.4 2.7 2.1 0 .6-.5 1.3-1.7 1.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8c-.9 0-2.4-.5-2.3-2.5 0 0 .1 2.1 2.3 2.1h4.8z",
    fill: "#FFB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "excel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#45B058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8 20.2c-.1 0-.2 0-.2-.1l-1.4-1.8-1.4 1.8c-.1.1-.1.1-.2.1-.2 0-.3-.1-.3-.2s0-.2.1-.2l1.4-1.9-1.3-1.8c-.1-.1-.1-.1-.1-.2s.1-.3.3-.3c.1 0 .1.1.2.1l1.3 1.8 1.3-1.8s.1-.1.2-.1.3.2.3.3c0 .1-.1.1-.1.2l-1.3 1.8L9 19.8l.1.1c0 .2-.2.3-.3.3zm3.7 0h-2c-.2 0-.4-.2-.4-.4v-3.9c0-.1.1-.3.3-.3.1 0 .2.2.2.3v3.8h1.9c.2 0 .3.1.3.2 0 .2-.1.3-.3.3zm2.6.1c-.6 0-1.1-.3-1.5-.6-.1-.1-.1-.1-.1-.2s.1-.3.2-.3.2 0 .2.1c.3.2.8.5 1.3.5.8 0 1-.5 1-.8 0-1.2-2.6-.5-2.6-2.1 0-.8.6-1.3 1.5-1.3.6 0 1.1.2 1.5.5v.2c0 .1-.1.3-.2.3s-.1-.1-.2-.1c-.3-.3-.7-.4-1.1-.4-.6 0-1 .3-1 .7 0 1 2.7.5 2.7 2.1 0 .7-.4 1.4-1.6 1.4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#349C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "exe",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1.1.9 1.9 1.9 1.9h17.2c1 0 1.9-.8 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#8199AF"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#617F9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 20.2H5.7c-.2 0-.4-.2-.4-.4v-3.7c0-.2.2-.4.4-.4H8c.2 0 .3.1.3.3 0 .1-.1.2-.3.2H5.9v1.5H8c.1 0 .2.1.2.2 0 .2-.1.3-.2.3H5.9v1.5H8c.2 0 .3.1.3.3 0 .1-.1.2-.3.2zm4.6.1c-.1 0-.2-.1-.2-.1L11 18.3l-1.4 1.9c-.1 0-.1.1-.2.1-.2 0-.3-.1-.3-.3 0-.1 0-.1.1-.2l1.4-1.9-1.3-1.8c-.1 0-.1-.1-.1-.2s.1-.2.3-.2c.1 0 .1 0 .2.1l1.3 1.7 1.3-1.7c0-.1.1-.1.2-.1s.2.1.2.2v.2l-1.4 1.8 1.5 1.9c0 .1.1.1.1.2s-.2.3-.3.3zm4-.1h-2.3c-.2 0-.4-.2-.4-.4v-3.7c0-.2.2-.4.4-.4h2.3c.2 0 .3.1.3.3 0 .1-.1.2-.3.2h-2.2v1.5h2.2c.1 0 .2.1.2.2 0 .2-.1.3-.2.3h-2.2v1.5h2.2c.2 0 .3.1.3.3 0 .1-.1.2-.3.2z",
    fill: "#fff"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "flash",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E53C3C"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#DE2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 16.2H5.9v1.4H8c.1 0 .2.1.2.3 0 .1-.1.2-.2.2H5.9v1.8c0 .2-.2.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.3.2-.4.4-.4h2.4c.1 0 .2.1.2.2 0 .2-.1.3-.3.3zm3.6 4h-2c-.2 0-.4-.2-.4-.4v-3.9c0-.2.1-.3.3-.3.1 0 .2.1.2.3v3.8h1.9c.2 0 .3.1.3.2 0 .2-.1.3-.3.3zm4.6 0c-.1 0-.2-.1-.3-.2l-.3-.8h-2.2l-.4.8c0 .1-.1.2-.2.2-.2 0-.3-.1-.3-.3v-.1l1.5-3.9c.1-.2.3-.3.5-.3s.4.1.4.3l1.6 3.9v.1c0 .1-.1.3-.3.3zm-1.7-4l-1 2.5h1.9l-.9-2.5z",
    fill: "#fff"
  }))), _symbol0 || (_symbol0 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "folder",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8 5.8a1.7 1.7 0 0 1 1.7 1.7v11.6a1.7 1.7 0 0 1-1.7 1.7H3.2a1.7 1.7 0 0 1-1.7-1.7V4.9a1.7 1.7 0 0 1 1.7-1.7h4.3c1.4 0 1.6.4 2.5 1.7.8 1 2.7.9 3.9.9z",
    fill: "#003462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 6.8H5a1.7 1.7 0 0 0-1.7 1.7v1.1l1.6-2.5h15.9l1.7 2.5V8.5a1.7 1.7 0 0 0-1.7-1.7z",
    fill: "#87c8f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2 20.8h17.6a1.7 1.7 0 0 0 1.7-1.7V8.8a1.7 1.7 0 0 0-1.7-1.7H5a1.7 1.7 0 0 0-1.7 1.7v10.3a1.7 1.7 0 0 1 0 .3.9.9 0 0 1-1.8 0 1.7 1.7 0 0 0 1.7 1.4z",
    fill: "#00a1e0"
  }))), _symbol1 || (_symbol1 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "gdoc",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3C8CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3 14h8.1v.8H5.3zm0 1.8h8.1v.8H5.3zm0 1.8h8.1v.8H5.3zm0 1.8h4.6v.8H5.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#2D6FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "gdocs",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3C8CEA",
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D6FE4",
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#fff",
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.2 16.9H8.4v.8h2c-.1 1.2-1.1 1.7-2 1.7-1.2 0-2.3-.9-2.3-2.2 0-1.3 1-2.3 2.3-2.3.9 0 1.5.6 1.5.6l.6-.6s-.8-.8-2.1-.8c-1.8 0-3.2 1.5-3.2 3.1s1.3 3.1 3.2 3.1c1.6 0 2.9-1.1 2.9-2.8-.1-.4-.1-.6-.1-.6z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "gform",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#673AB7",
    d: "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#45317C",
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#fff",
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.3 14.8c0-.2-.1-.3-.3-.3h-.5c-.1 0-.2.1-.2.3v.5c0 .1.1.2.2.2H6c.2 0 .3-.1.3-.2v-.5zm7 0c0-.2-.1-.3-.2-.3H7.2c-.2 0-.3.1-.3.3v.5c0 .1.1.2.3.2h5.9c.1 0 .2-.1.2-.2v-.5zm-7 2.3c0-.1-.1-.2-.3-.2h-.5c-.1 0-.2.1-.2.2v.5c0 .2.1.3.2.3H6c.2 0 .3-.1.3-.3v-.5zm7 0c0-.1-.1-.2-.3-.2H7.2c-.1 0-.3.1-.3.2v.5c0 .2.2.3.3.3H13c.2 0 .3-.1.3-.3v-.5zm-7 2.4c0-.2-.1-.3-.3-.3h-.5c-.1 0-.2.1-.2.3v.5c0 .1.1.2.2.2H6c.2 0 .3-.1.3-.2v-.5zm7 0c0-.2-.1-.3-.2-.3H7.2c-.2 0-.3.1-.3.3v.5c0 .1.1.2.3.2h5.9c.1 0 .2-.1.2-.2v-.5z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "gpres",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F8BE46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3 14v4.5H10V14H5.3zm4.2 3.7H5.7v-2.8h3.8v2.8zm.3-2v.9h3.1v2.8H9.1v-1.1h-.4v1.9h4.7v-4.5H9.8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#F6AD34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "gsheet",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#20A971"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3 14v6.2h8.1V14H5.3zm2.4 5.7H5.8v-1.3h1.9v1.3zm0-1.9H5.8v-1.3h1.9v1.3zm0-1.9H5.8v-1.3h1.9v1.3zm5.1 3.8H8.3v-1.3h4.5v1.3zm0-1.9H8.3v-1.3h4.5v1.3zm0-1.9H8.3v-1.3h4.5v1.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#189355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.4c0 .7.4 2.2 2.3 2.2h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "html",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F7622C"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#F54921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.6 19.1s-.1 0-.1-.1l-2.9-1.2c-.1-.1-.3-.3-.3-.5s.2-.4.3-.5l2.9-1.2c0-.1.1-.1.1-.1.2 0 .3.2.3.4 0 .1 0 .2-.2.3l-2.6 1.1 2.6 1.1c.2.1.2.2.2.3 0 .2-.1.4-.3.4zm3.2-4.2l-1.7 5c0 .2-.2.2-.3.2-.2 0-.4-.1-.4-.3 0 0 0-.1.1-.1l1.6-5c.1-.1.2-.2.4-.2s.3.1.3.3v.1zm3.8 2.9L12.8 19c-.1.1-.1.1-.2.1s-.3-.2-.3-.4c0-.1.1-.2.2-.3l2.6-1.1-2.6-1.1c-.1-.1-.2-.2-.2-.3 0-.2.2-.4.3-.4.1 0 .1 0 .2.1l2.8 1.2c.2.1.3.3.3.5s-.1.4-.3.5z",
    fill: "#fff"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "image",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1.1.9 1.9 1.9 1.9h17.2c1 0 1.9-.8 1.9-1.9V7.6L15.4 0h-12z",
    fill: "#49C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#37BB91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.3 20.2v-7.9h7.8v7.9H5.3zm7-7.1H6.1v4.7h6.2v-4.7zm-3.5 3.1l1.4-1.9.5.8.5-.2.4 2.1H6.7L8 15.8l.8.4zm-1.5-1.3c-.3 0-.6-.3-.6-.6s.3-.6.6-.6.6.3.6.6-.3.6-.6.6z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "keynote",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#DB7A2A"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#D25B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.2 20.3c-.1 0-.2-.1-.2-.1l-1.7-2-.4.5V20c0 .1-.2.2-.3.2-.2 0-.3-.1-.3-.2v-4.1c0-.1.1-.2.3-.2.1 0 .3.1.3.2V18l1.9-2.2c.1-.1.1-.1.2-.1.2 0 .3.1.3.2s0 .1-.1.2l-1.5 1.7 1.7 2c0 .1.1.1.1.2s-.2.3-.3.3zm4.1-.1H9.9c-.2 0-.4-.2-.4-.4v-3.7c0-.2.2-.4.4-.4h2.4c.1 0 .2.1.2.3 0 .1-.1.2-.2.2h-2.2v1.5h2.1c.2 0 .3.1.3.2s-.1.3-.3.3h-2.1v1.5h2.2c.1 0 .2.1.2.3 0 .1-.1.2-.2.2zm4.6-4.1l-1.5 2.2V20c0 .1-.1.2-.3.2-.1 0-.3-.1-.3-.2v-1.7l-1.5-2.2v-.2c0-.1.1-.2.3-.2 0 0 .1 0 .2.1l1.3 2 1.4-2c0-.1.1-.1.2-.1s.3.1.3.2-.1.1-.1.2z",
    fill: "#fff"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "library_folder",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003462",
    d: "M20.8 5.8c1 0 1.7.8 1.7 1.7v11.6c0 1-.7 1.7-1.7 1.7H3.2c-.9 0-1.7-.7-1.7-1.7V4.9c0-1 .8-1.7 1.7-1.7h4.3c1.4 0 1.6.4 2.5 1.7.8 1 2.7.9 3.9.9h6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87C8F2",
    d: "M20.8 6.8H4.9c-.9 0-1.6.7-1.6 1.7v1.1l1.6-2.5h15.9l1.7 2.5V8.5c0-1-.7-1.7-1.7-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1E0",
    d: "M3.2 20.8h17.6c1 0 1.7-.7 1.7-1.7V8.8c0-.9-.7-1.7-1.7-1.7H5c-.9 0-1.7.7-1.7 1.7v10.6c0 .5-.4.9-.9.9s-.9-.4-.9-.9c.2.8.9 1.4 1.7 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 14.2h1.3v4.3h-1.3zm2.3 0h1.3v4.3h-1.3zm5.5-2.3l-5.6-2.3c-.2-.1-.3-.1-.4-.1-.1 0-.2 0-.5.1l-5.6 2.3c-.1.1-.2.2-.2.3v.4c0 .2.2.3.4.3h1.1v5.3c0 .1.1.3.3.3h1.7v-4.3h-.7c-.1 0-.2-.1-.2-.3v-.4c0-.2.1-.2.2-.2h6.9c.1 0 .2 0 .2.2v.4c0 .2-.1.3-.2.3h-.7v4.3h1.7c.2 0 .3-.2.3-.4v-5.2h1.1c.2 0 .3-.2.3-.3v-.3c.1-.2 0-.3-.1-.4zm-6 .2c-.5 0-.8-.3-.8-.7 0-.4.4-.7.8-.7s.7.3.7.7c0 .4-.3.7-.7.7z",
    fill: "#fff"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "link",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0C8FE8"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#0973E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.1 13.4c-.8-.8-2-.8-2.8 0l-1.2 1.1c-.8.8-.8 2 0 2.8.2.2.5.2.7 0 .2-.2.2-.4 0-.6-.5-.4-.5-1.1 0-1.5L9.9 14c.4-.4 1.1-.4 1.5 0 .5.4.5 1.1 0 1.5l-.5.6c.1.3.2.7.2 1.1l1-1c.8-.8.8-2.1 0-2.8zm-2.9 2.2c-.2.2-.2.5 0 .6.4.5.4 1.1 0 1.6l-1.1 1.1c-.5.4-1.1.4-1.6 0-.4-.4-.4-1.1 0-1.5l.6-.6c-.2-.3-.2-.7-.2-1.1l-1 1c-.8.8-.8 2.1 0 2.9.8.7 2 .7 2.8 0l1.2-1.2c.7-.8.7-2 0-2.8-.2-.2-.5-.2-.7 0z",
    fill: "#fff"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "mp4",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fill: "#9B64B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#824B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.4 20.2c-.1 0-.3-.1-.3-.3v-3.4l-1.5 3.6c0 .1 0 .1-.1.1s-.1 0-.1-.1l-1.5-3.6v3.4c0 .2-.2.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.3.2-.5.5-.5.1 0 .3.1.4.3L7.5 19l1.3-3.1c.1-.2.3-.3.4-.3.3 0 .5.2.5.5v3.8c0 .2-.1.3-.3.3zm3.3-1.8h-1.2v1.5c0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.3.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.3 0 .8-.5 1.4-1.4 1.4zm0-2.2h-1.2v1.7h1.2c.5 0 .9-.4.9-.9s-.4-.8-.9-.8zm5.2 2.8h-.5v.9c0 .2-.1.3-.2.3-.2 0-.3-.1-.3-.3V19H15c-.2 0-.3-.1-.3-.3 0 0 0-.1.1-.2l1.8-2.7c.1-.1.2-.2.4-.2s.4.2.4.5v2.4h.5c.1 0 .2.1.2.3 0 .1-.1.2-.2.2zm-1-2.8l-1.6 2.3h1.6v-2.3z",
    fill: "#fff"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "overlay",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#A382D8"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#8C62CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.3 12.9v5.3h5.5v-5.3H5.3zm2 2v5.3h5.5v-5.3H7.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBBBEF",
    d: "M7.3 14.9h3.5v3.3H7.3z"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "pack",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4E74B7"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#3A57A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.4 15.3v4.5c0 .2-.2.4-.4.4H5.7c-.2 0-.4-.2-.4-.4v-4.5-.1l.6-1.8c.1-.2.2-.3.4-.3h5.1c.2 0 .4.1.4.3l.6 1.8v.1zm-.9 0l-.4-1.3H6.7l-.5 1.3h5.3z",
    fill: "#fff"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "pages",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6A6AE2"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#4F4FDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.1 18.4H5.9v1.5c0 .2-.2.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.3.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.3s-.5 1.4-1.4 1.4zM7 16.2H5.9v1.7H7c.6 0 .9-.4.9-.9s-.3-.8-.9-.8zm4.6 4.1c-1.3 0-2.4-1-2.4-2.4s1.1-2.3 2.4-2.3c.6 0 1.2.2 1.5.6.1.1.1.1.1.2s-.1.3-.3.3c0 0-.1-.1-.2-.1-.2-.3-.7-.5-1.1-.5-1 0-1.8.7-1.8 1.8s.8 1.9 1.8 1.9c.5 0 .9-.3 1.2-.5v-1h-1.4c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h1.5c.3 0 .4.1.4.4v.8c0 .7-.9 1.2-1.7 1.2zm4.3-.1c-.7 0-1.2-.2-1.6-.5-.1-.1-.1-.1-.1-.2 0-.2.1-.3.3-.3 0 0 .1 0 .1.1.3.2.8.4 1.3.4.8 0 1.1-.4 1.1-.7 0-1.2-2.7-.5-2.7-2.2 0-.7.6-1.2 1.5-1.2.6 0 1.1.2 1.5.5 0 0 .1.1.1.2s-.1.2-.3.2h-.2c-.3-.3-.7-.4-1.1-.4-.6 0-.9.3-.9.7 0 1 2.6.4 2.6 2.1 0 .7-.4 1.3-1.6 1.3z",
    fill: "#fff"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "pdf",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8C181A",
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B0D12",
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.3 2.1h4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#fff",
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.1 18.4H5.8v1.5c0 .2-.1.3-.3.3-.1 0-.2-.1-.2-.3v-3.8c0-.2.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.3 0 .8-.5 1.4-1.4 1.4zM7 16.2H5.8v1.7H7c.6 0 .9-.3.9-.9s-.3-.8-.9-.8zm3.9 4H9.8c-.2 0-.4-.2-.4-.4v-3.7c0-.2.2-.4.4-.4h1.1c1.4 0 2.4.9 2.4 2.2s-.9 2.3-2.4 2.3zm0-4H10v3.5h.9c1.1 0 1.8-.8 1.8-1.8 0-.9-.6-1.7-1.8-1.7zm6.2 0h-2.2v1.4H17c.2 0 .3.1.3.3s-.2.2-.3.2h-2.1v1.8c0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.2.2-.4.4-.4h2.4c.1 0 .2.1.2.2s-.1.3-.2.3z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "ppt",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E34221"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#DC3119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.1 18.4H5.9v1.5c0 .2-.2.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.3.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.3 0 .8-.5 1.4-1.4 1.4zM7 16.2H5.9v1.7H7c.6 0 .9-.4.9-.9s-.3-.8-.9-.8zm4.2 2.2H10v1.5c0 .2-.1.3-.3.3-.1 0-.3-.1-.3-.3v-3.8c0-.3.2-.4.4-.4h1.4c.9 0 1.5.6 1.5 1.3 0 .8-.6 1.4-1.5 1.4zm0-2.2H10v1.7h1.2c.5 0 .9-.4.9-.9s-.4-.8-.9-.8zm5.3 0h-1.3v3.7c0 .2-.1.3-.2.3-.2 0-.3-.1-.3-.3v-3.7h-1.2c-.2 0-.3-.1-.3-.3 0-.1.1-.2.3-.2h3c.1 0 .2.1.2.2 0 .2-.1.3-.2.3z",
    fill: "#fff"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "psd",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1.1.9 1.9 1.9 1.9h17.2c1 0 1.9-.8 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0C77C6"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#0959B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.1 18.4H5.9v1.5c0 .2-.2.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.3.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.3 0 .8-.5 1.4-1.4 1.4zM7 16.2H5.9v1.7H7c.6 0 .9-.4.9-.9s-.3-.8-.9-.8zm3.9 4.1c-.7 0-1.2-.3-1.6-.6-.1-.1-.1-.1-.1-.2s.1-.3.3-.3c0 0 .1 0 .1.1.4.2.8.4 1.3.4.8 0 1.1-.4 1.1-.7 0-1.2-2.7-.5-2.7-2.2 0-.7.7-1.2 1.5-1.2.6 0 1.1.2 1.5.5.1 0 .1.1.1.2s-.1.2-.3.2H12c-.4-.3-.8-.4-1.2-.4-.5 0-.9.3-.9.7 0 1 2.6.4 2.6 2.1 0 .7-.4 1.3-1.6 1.3zm4.2-.1H14c-.3 0-.4-.2-.4-.4v-3.7c0-.3.1-.4.4-.4h1.1c1.4 0 2.3.9 2.3 2.2 0 1.3-.9 2.3-2.3 2.3zm0-4h-1v3.5h1c1.1 0 1.7-.8 1.7-1.8s-.6-1.7-1.7-1.7z",
    fill: "#fff"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "quip_doc",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3D87F5",
    d: "M1.5 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.9L15.4 0h-12c-1 0-1.9.9-1.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#fff",
    d: "M15.4 0l7.1 7.9h-5.2c-1.1 0-2-.9-2-2l.1-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#216AC1",
    d: "M15.4 6v.3c0 1.1.8 2 1.9 2h5.2v-.4h-5.2c-1.1 0-1.9-.9-1.9-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.3 17.5H7.7c-.1 0-.3.1-.3.3s.1.3.3.3h2.6c.2 0 .3-.1.3-.3s-.1-.3-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.7 15.5h2.6c.1 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H7.7c-.2 0-.3.1-.3.3 0 .2.1.3.3.3zm-.9.7c-.1 0-.3.1-.3.3 0 .2.1.3.3.3h4.3c.2 0 .3-.1.3-.3 0-.1-.1-.3-.3-.3H6.8zm4.8-2.4c-1.5-1.4-3.8-1.4-5.3 0-1.4 1.5-1.4 3.8 0 5.3.7.7 1.7 1.2 2.7 1.2h3.4c.2 0 .4-.2.4-.4v-3.4c0-1.1-.5-2-1.2-2.7zm.6 5.9H9c-.9 0-1.7-.4-2.3-1-.6-.7-.9-1.5-.9-2.4.1-1.6 1.4-2.9 3-3H9c1.7 0 3.2 1.5 3.2 3.2v3.2z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "quip_sheet",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2CAB21",
    d: "M1.5 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.9L15.4 0h-12c-1 0-1.9.9-1.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#fff",
    d: "M15.4 0l7.1 7.9h-5.2c-1.1 0-2-.9-2-2l.1-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#189355",
    d: "M15.4 6v.3c0 1.1.8 2 1.9 2h5.2v-.4h-5.2c-1.1 0-1.9-.9-1.9-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.3 17.5H7.7c-.1 0-.3.1-.3.3s.1.3.3.3h2.6c.2 0 .3-.1.3-.3s-.1-.3-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.7 15.5h2.6c.1 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H7.7c-.2 0-.3.1-.3.3 0 .2.1.3.3.3zm-.9.7c-.1 0-.3.1-.3.3 0 .2.1.3.3.3h4.3c.2 0 .3-.1.3-.3 0-.1-.1-.3-.3-.3H6.8zm4.8-2.4c-1.5-1.4-3.8-1.4-5.3 0-1.4 1.5-1.4 3.8 0 5.3.7.7 1.7 1.2 2.7 1.2h3.4c.2 0 .4-.2.4-.4v-3.4c0-1.1-.5-2-1.2-2.7zM9 19.7c-.9 0-1.7-.4-2.3-1-.6-.7-.9-1.5-.9-2.4.1-1.6 1.4-2.9 3-3H9c1.7 0 3.2 1.5 3.2 3.2v3.2H9z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "quip_slide",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#8D3DF5",
    d: "M1.5 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.9L15.4 0h-12c-1 0-1.9.9-1.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#fff",
    d: "M15.4 0l7.1 7.9h-5.2c-1.1 0-2-.9-2-2l.1-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#6D2BD6",
    d: "M15.4 6v.3c0 1.1.8 2 1.9 2h5.2v-.4h-5.2c-1.1 0-1.9-.9-1.9-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.3 17.5H7.7c-.1 0-.3.1-.3.3s.1.3.3.3h2.6c.2 0 .3-.1.3-.3s-.1-.3-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.7 15.5h2.6c.1 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H7.7c-.2 0-.3.1-.3.3 0 .2.1.3.3.3zm-.9.7c-.1 0-.3.1-.3.3 0 .2.1.3.3.3h4.3c.2 0 .3-.1.3-.3 0-.1-.1-.3-.3-.3H6.8zm4.8-2.4c-1.5-1.4-3.8-1.4-5.3 0-1.4 1.5-1.4 3.8 0 5.3.7.7 1.7 1.2 2.7 1.2h3.4c.2 0 .4-.2.4-.4v-3.4c0-1.1-.5-2-1.2-2.7zM9 19.7c-.9 0-1.7-.4-2.3-1-.6-.7-.9-1.5-.9-2.4.1-1.6 1.4-2.9 3-3H9c1.7 0 3.2 1.5 3.2 3.2v3.2H9z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "rtf",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#00A1EE"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#0089E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 18.3l.9 1.5.1.1c0 .2-.2.3-.3.3-.1 0-.2-.1-.2-.1l-1.1-1.7h-.9v1.5c0 .2-.2.3-.3.3-.2 0-.3-.1-.3-.3V16c0-.2.2-.4.4-.4h1.4c.8 0 1.4.6 1.4 1.4 0 .8-.5 1.3-1.1 1.3zm-1.5-2.2v1.8H7c.6 0 .9-.4.9-.9s-.3-.9-.9-.9H5.9zm6.5 0h-1.2v3.8c0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.3v-3.8H9.4c-.1 0-.2-.1-.2-.2s.1-.3.2-.3h3c.1 0 .3.2.3.3 0 .1-.2.2-.3.2zm3.9 0h-2.2v1.5h2.1c.2 0 .3.1.3.3 0 .1-.1.2-.3.2h-2.1v1.8c0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.3V16c0-.2.2-.4.4-.4h2.4c.1 0 .2.2.2.3 0 .1-.1.2-.2.2z",
    fill: "#fff"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "slide",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1AB6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3 13v7.2h7.5V13H5.3zm6.8 5.8H6v-4.4h6.1v4.4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#13A3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "stypi",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fill: "#DDD965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#C1BC45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.1H5.9c-.3 0-.6.2-.6.5v6c0 .4.3.6.6.6h5l2.2-2.2v-4.4c0-.3-.2-.5-.6-.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBD75D",
    d: "M6.7 16.3h5.1v.6H6.7zm0-1.3h5.1v.6H6.7zm0 2.7H10v.6H6.7z"
  })))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "txt",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F9CA06"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.3 2.1h4.8z",
    fill: "#F7BC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.4c0 .7.4 2.2 2.3 2.2h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.1H7.3v3.8c0 .2-.1.3-.3.3-.1 0-.3-.1-.3-.3v-3.8H5.5c-.1 0-.2-.1-.2-.2s.1-.3.2-.3h3c.2 0 .3.2.3.3 0 .1-.1.2-.3.2zm4.4 4.1c-.1 0-.1 0-.2-.1l-1.4-1.9-1.4 1.9c0 .1-.1.1-.2.1s-.3-.1-.3-.3l.1-.1 1.5-2L9.6 16l-.1-.1c0-.2.2-.3.3-.3.1 0 .2 0 .2.1l1.3 1.7 1.3-1.7c.1-.1.1-.1.2-.1.2 0 .3.1.3.3 0 0 0 .1-.1.1l-1.3 1.8 1.4 2c.1 0 .1.1.1.1 0 .2-.1.3-.3.3zm4.2-4.1h-1.2v3.8c0 .2-.1.3-.3.3-.1 0-.3-.1-.3-.3v-3.8h-1.2c-.1 0-.2-.1-.2-.2s.1-.3.2-.3h3c.2 0 .3.2.3.3 0 .1-.1.2-.3.2z",
    fill: "#fff"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "unknown",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fill: "#8199AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#617F9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "video",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#8E4C9E"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#713985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.7 17.1c0 .1-.1.2-.2.3 0 .1-1.9 1.7-4.4 2.7h-.5c-.1-.1-.2-.2-.2-.4 0-.1-.1-1.3-.1-2.6s.1-2.6.1-2.6c0-.2.1-.3.2-.4.1-.1.2-.1.3-.1h.2c2.5 1 4.4 2.6 4.4 2.7.1.1.2.2.2.4z",
    fill: "#fff"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "visio",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#496AB3"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#374FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 16l-1.5 3.9c-.1.2-.3.3-.5.3s-.4-.1-.4-.3L5.3 16v-.1c0-.1.1-.3.3-.3.1 0 .2.1.3.2l1.4 3.7 1.5-3.7c0-.1.1-.2.3-.2.1 0 .3.1.3.3 0 0 0 .1-.1.1zm1.2 4.2c-.1 0-.3-.1-.3-.3v-4c0-.2.2-.3.3-.3.2 0 .3.1.3.3v4c0 .2-.1.3-.3.3zm3 0c-.7 0-1.2-.2-1.6-.5-.1-.1-.1-.2-.1-.2 0-.2.1-.3.3-.3h.1c.4.3.8.5 1.3.5.8 0 1.1-.4 1.1-.7 0-1.2-2.7-.6-2.7-2.2 0-.7.7-1.2 1.5-1.2.6 0 1.1.2 1.5.5.1 0 .1.1.1.2s-.1.2-.3.2h-.1c-.4-.3-.8-.4-1.2-.4-.5 0-.9.3-.9.7 0 1 2.6.4 2.6 2.1 0 .7-.4 1.3-1.6 1.3z",
    fill: "#fff"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "webex",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fill: "#80BC4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#60AB38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 20.2c1.9-.1 3.4-1.7 3.4-3.7 0-1.9-1.5-3.5-3.4-3.6v7.3z",
    fill: "#CFE8AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8 20.2c-2-.1-3.5-1.7-3.5-3.7s1.5-3.5 3.5-3.6v7.3z",
    fill: "#fff"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "word",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#14A9DA"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#0F93D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 20.2H5.7c-.2 0-.4-.2-.4-.4v-3.7c0-.2.2-.4.4-.4h1.1c1.4 0 2.4 1 2.4 2.3 0 1.2-1 2.2-2.4 2.2zm0-4h-.9v3.5h.9c1.1 0 1.8-.8 1.8-1.7 0-1-.6-1.8-1.8-1.8zm5.4 4.1c-1.3 0-2.2-1-2.2-2.3s.9-2.4 2.2-2.4c1.4 0 2.3 1 2.3 2.4 0 1.3-.9 2.3-2.3 2.3zm0-4.2c-1 0-1.6.8-1.6 1.9 0 1 .6 1.8 1.6 1.8 1.1 0 1.7-.8 1.7-1.8 0-1.1-.6-1.9-1.7-1.9zm7 .2v.2c0 .1-.1.2-.2.2s-.2 0-.2-.1c-.3-.3-.7-.5-1.1-.5-1 0-1.8.8-1.8 1.9 0 1 .8 1.8 1.8 1.8.4 0 .8-.2 1.1-.5 0-.1.1-.1.2-.1s.2.1.2.3v.1c-.4.4-.9.7-1.5.7-1.3 0-2.4-1-2.4-2.4s1.1-2.3 2.4-2.3c.6 0 1.1.3 1.5.7z",
    fill: "#fff"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "xml",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FC7B24"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#FB5C1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.8 20.2c-.1 0-.2 0-.2-.1l-1.4-1.9-1.4 1.9c-.1.1-.2.1-.2.1-.2 0-.3-.1-.3-.3v-.1l1.5-2L5.4 16v-.1c0-.2.1-.3.3-.3 0 0 .1 0 .2.1l1.3 1.7 1.3-1.7c0-.1.1-.1.2-.1s.2.1.2.3v.1l-1.4 1.8 1.5 2v.1c0 .2-.1.3-.2.3zm5.4 0c-.2 0-.3-.1-.3-.3v-3.5l-1.5 3.7c0 .1-.1.1-.1.1-.1 0-.2 0-.2-.1l-1.5-3.7v3.5c0 .2-.1.3-.3.3-.1 0-.2-.1-.2-.3v-3.8c0-.3.2-.5.4-.5s.4.1.5.3l1.3 3.1 1.3-3.1c0-.2.2-.3.4-.3.3 0 .5.2.5.5v3.8c0 .2-.2.3-.3.3zm3.9-.1h-2c-.2 0-.4-.1-.4-.4v-3.8c0-.2.1-.3.3-.3.1 0 .2.1.2.3v3.7h1.9c.2 0 .3.2.3.3 0 .1-.1.2-.3.2z",
    fill: "#fff"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "zip",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#8199AF"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
    fill: "#617F9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
    opacity: 0.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 20.2H5.6c-.2 0-.3-.1-.3-.3v-.2l2.6-3.5H5.5c-.1 0-.2-.1-.2-.2 0-.2.1-.3.2-.3h2.8c.2 0 .3.1.3.3 0 .1 0 .2-.1.2L6 19.7h2.4c.1 0 .3.1.3.3 0 .1-.2.2-.3.2zm1.5.1c-.1 0-.3-.2-.3-.3v-4.1c0-.1.2-.2.3-.2.2 0 .3.1.3.2V20c0 .1-.1.3-.3.3zm3.3-1.9H12V20c0 .1-.1.3-.3.3-.2 0-.3-.2-.3-.3v-3.9c0-.2.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.4s-.5 1.3-1.4 1.3zm0-2.2H12v1.7h1.2c.5 0 .9-.3.9-.8s-.4-.9-.9-.9z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctypeSprite);
export default __webpack_public_path__ + "static/media/doctype-sprite.ba3dc5e9fe83eebd3ececa5b4198883c.svg";
export { ForwardRef as ReactComponent };